import { animated } from "@react-spring/web";
import type { LinkPath } from "./types";

export function LinkCurve({
  link,
  spring,
  showArrow,
}: {
  link: LinkPath;
  spring: { value: any };
  showArrow: boolean;
}) {
  const dx = link.x2 - link.x1;
  const horizontalLength = Math.abs(dx) * 0.2;
  const midX1 = link.x1 + horizontalLength;
  const midX2 = link.x2 - horizontalLength;
  const curveExtension = Math.abs(dx) * 0.15;
  const cx1 = midX1 + curveExtension;
  const cy1 = link.y1;
  const cx2 = midX2 - curveExtension;
  const cy2 = link.y2;
  const curvePath = `M ${link.x1} ${link.y1} L ${midX1} ${link.y1} C ${cx1} ${cy1}, ${cx2} ${cy2}, ${midX2} ${link.y2} L ${link.x2} ${link.y2}`;
  const arrowX = link.x2 - 10;
  return (
    <g>
      <animated.path
        d={curvePath}
        stroke="#2C2C2C"
        strokeWidth={1}
        strokeDashoffset={showArrow ? spring.value : 0}
        strokeDasharray={showArrow ? 1 : undefined}
        fill="none"
        opacity={0.6}
        pathLength={showArrow ? 1 : undefined}
      />
      <animated.path
        d="M -3 -2.5 L 0 0 L -3 2.5"
        transform={`translate(${arrowX},${link.y2})`}
        fill="none"
        stroke="#2C2C2C"
        strokeWidth={1}
        strokeLinecap="round"
        strokeLinejoin="round"
        opacity={
          showArrow
            ? spring.value.to((v: number) => (v < 0.05 ? 0.85 : 0))
            : 0.85
        }
      />
    </g>
  );
}
